import { useApi } from "shared/services/api/useApi";
import { useCallback } from "react";

const useProjectPlannerAPI = () => {
    const { getDataAsync } = useApi();

    const getProjectPlannerApiCall = useCallback(async (projectId) => {
        const response = await getDataAsync("getProjectById", {
            urlParams: [
                { name: "$projectId", value: projectId },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    const getProjectPlannerDataApiCall = useCallback(async (projectId) => {
        const response = await getDataAsync("projectPlannerData", {
            urlParams: [
                { name: "$projectId", value: projectId },
            ],
        });

        const result = response.status === 204
            ? null
            : response.json();

        return result;

    }, [getDataAsync]);

    return {
        getProjectPlannerApiCall,
        getProjectPlannerDataApiCall,
    };
};

export default useProjectPlannerAPI;
